export const isLoggedIn = () => {
  return {
    type: "SIGN_IN",
  };
};

export const userDetails = (details) => {
  return {
    type: "USER_DETAILS",
    payload: details,
  };
};
export const shopDetails = (details) => {
  return {
    type: "SHOP_DETAILS",
    payload: details,
  };
};
export const salesChannelAction = (details) => {
  return {
    type: "SALES_CHANNEL",
    payload: details,
  };
};
export const removeSalesChannel = (details) => {
  return {
    type: "REMOVE_SALES_CHANNEL",
    payload: details,
  };
};
export const salesItem = (details) => {
  return {
    type: "ADD_ITEMS",
    payload: details,
  };
};
export const salesItemRemove = (details) => {
  return {
    type: "REMOVE_ITEMS",
    payload: details,
  };
};
export const customerItems = (details) => {
  return {
    type: "CUSTOMER_ITEMS",
    payload: details,
  };
};
export const removeCustomerItems = (details) => {
  return {
    type: "REMOVE_CUSTOMER_ITEMS",
    payload: details,
  };
};
export const removeAllCustomerItems = (details) => {
  return {
    type: "REMOVE_ALL_ITEMS",
    payload: details,
  };
};
export const allCustomers = (details) => {
  return {
    type: "CUSTOMERS",
    payload: details,
  };
};

export const deleteCustomer = (details) => {
  return {
    type: "DELETE_CUSTOMER",
    payload: details,
  };
};
export const shopSalesHistory = (details) => {
  return {
    type: "SALES_HISTORY",
    payload: details,
  };
};
export const removeShopSalesHistory = (details) => {
  return {
    type: "REMOVE_SALES_HISTORY",
    payload: details,
  };
};
export const salesRecord = (details) => {
  return {
    type: "SALES_RECORD",
    payload: details,
  };
};
export const clearShopDetails = (details) => {
  return {
    type: "CLEAR_SHOP_DETAILS",
    payload: details,
  };
};
